import React from 'react';
import { number, string } from 'prop-types';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { nanoid } from 'nanoid';
import { arrayOf } from 'prop-types';
import { shape } from 'prop-types';

import { DELIVERY_STATUS } from '~constants/delivery';
import DeliveryStatusBadge from '~components/DeliveryStatusBadge';
import DeliveryActions from '~redux/Delivery/actions';
import ModalActions from '~redux/Modal/actions';

import styles from '../../styles.module.scss';
import { DELIVERY_ACTIONS_MODAL } from '../../../DeliveryActionsModal/constants';

function ItemsAndDispatchMethod({ itemsLength, dispatchMethod, deliveries, item }) {
  const dispatch = useDispatch();
  const deliveryStatus = DELIVERY_STATUS[deliveries?.[0]?.status] || null;

  const handleErrorDeliveryActions = () => {
    dispatch(
      DeliveryActions.setDeliveryItems({
        ...item,
        requestId: nanoid(),
        error: DELIVERY_STATUS.REJECTED
      })
    );
    dispatch(ModalActions.openModal(DELIVERY_ACTIONS_MODAL));
  };

  return (
    <div className={`row middle space-between m-left-2 m-right-2 ${styles.border}`}>
      <span className={styles.subtitle}>{i18next.t('OrdersDetails:items', { length: itemsLength })}</span>
      <div className="row middle">
        <span className="text-charade font-size-14 bold m-right-2">
          {i18next.t(`OrdersDetails:${dispatchMethod}`)}
        </span>
        {deliveryStatus && (
          <DeliveryStatusBadge status={deliveryStatus} onClick={handleErrorDeliveryActions} />
        )}
      </div>
    </div>
  );
}

ItemsAndDispatchMethod.propTypes = {
  dispatchMethod: string.isRequired,
  itemsLength: number.isRequired,
  deliveries: arrayOf(shape({})),
  item: shape({})
};

export default ItemsAndDispatchMethod;
